import { render } from "./FilterItemAddData.vue?vue&type=template&id=12721cba"
import script from "./FilterItemAddData.vue?vue&type=script&lang=js"
export * from "./FilterItemAddData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__